import { FETCH_COUNTRIES_ERROR, FETCH_COUNTRIES_START, FETCH_COUNTRIES_SUCCESS, FETCH_COUNTRY_STATES_ERROR, FETCH_COUNTRY_STATES_SUCCESS } from '../../actions/common/addressAction';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    countries: [],
    states: []
};

const addrressReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_COUNTRIES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_COUNTRIES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, countries: _.cloneDeep(action.countries) };
        }
        case FETCH_COUNTRIES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '', countries: [] };
        }
        case FETCH_COUNTRY_STATES_SUCCESS: {
            return { ...state, loading: false, error: action.error, message: '', states: _.cloneDeep(action.states) };
        }
        case FETCH_COUNTRY_STATES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '', states: [] };
        }
        default:
            return state;
    }
}

export default addrressReducer;
